class PanelManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }
    
    run() {
        document.querySelectorAll('[data-panel]').forEach(el => {
            const mAddressFillForm = new Panel(el, this)
            mAddressFillForm.run()
        })
    }
}

class Panel {
    constructor(el, parent) {
        this.el = el
        this.parent = parent
    }

    run() {
        this.el.addEventListener('view-update', () => {
            this.update()
        })
        this.el.addEventListener('change', (ev) => {
            if (!ev.target.matches('[data-panel-controller]')) {
                return
            }
            this.update()
        })
    }

    update() {
        if ('show' === this.getStatus()) {
            this.show()
        } else {
            this.hide()
        }
    }

    getStatus() {
        const status = Array.from(this.el.querySelectorAll('[data-panel-controller]')).reduce((carry, el) => {
            if (true === el.checked) {
                return el.dataset.panelController
            }
            return carry
        }, 'none')
        return status
    }

    show() {
        this.el.querySelectorAll('[data-panel-content]').forEach(el => {
            el.style.display = 'block'
        })
    }

    hide() {
        this.el.querySelectorAll('[data-panel-content]').forEach(el => {
            el.style.display = 'none'
        })
    }
}

export default PanelManager